// src/redux/reducers/siteReducer.js
import { SET_ALERT_TREND } from "../actions/alerttrendAtion";

const initialState = {
    alerttrendList: [],
};

const alerttrendReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALERT_TREND:
      return {
        ...state,
        alerttrendList: action.payload,
      };
    default:
      return state;
  }
};

export default alerttrendReducer;
